import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "layout-menu",
  class: "layout-menu menu-vertical menu bg-menu-theme"
}
const _hoisted_2 = { class: "app-brand" }
const _hoisted_3 = {
  href: "index.html",
  class: "app-brand-link"
}
const _hoisted_4 = { class: "app-brand-logo" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "app-brand-text menu-text fw-bold ms-2" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  href: "javascript:void(0);",
  class: "layout-menu-toggle menu-link text-large ms-auto"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "menu-inner-shadow" }, null, -1)
const _hoisted_11 = { class: "menu-inner" }
const _hoisted_12 = { class: "menu-item" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "menu-icon icon-dashboard" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { "data-i18n": "Dashboard" }, "Dashboard", -1)
const _hoisted_15 = { class: "menu-item" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "menu-icon icon-quotation" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { "data-i18n": "Quotation" }, "Quotation", -1)
const _hoisted_18 = { class: "menu-item" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "menu-icon icon-history" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { "data-i18n": "Purchase History" }, "Purchase History", -1)
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<div class=\"bottom-div\"><p class=\"support\"><a href=\"mailto:support@saat.my\" target=\"_blank\"><i class=\"fa fa-envelope support-icon\"></i><span class=\"text\">support@saat.my</span></a></p><p class=\"support\"><a href=\"tel:+60102163420\" target=\"_blank\"><i class=\"fa fa-phone support-icon\"></i><span class=\"text\">010-216 3420</span></a></p><br></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createElementVNode("img", {
            src: _ctx.url + 'assets/img/customer-portal/logo-saat.png',
            alt: "Logo - Saat",
            width: "44",
            height: "51"
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("span", _hoisted_6, [
          _createElementVNode("img", {
            src: _ctx.url + 'assets/img/customer-portal/logo-saat-text.png',
            alt: "Logo - Saat",
            width: "70",
            height: "52"
          }, null, 8, _hoisted_7)
        ])
      ]),
      _createElementVNode("a", _hoisted_8, [
        _createElementVNode("img", {
          src: _ctx.url + 'assets/img/customer-portal/icon-menu.png',
          alt: "",
          width: "15",
          height: "12"
        }, null, 8, _hoisted_9)
      ])
    ]),
    _hoisted_10,
    _createElementVNode("ul", _hoisted_11, [
      _createElementVNode("li", _hoisted_12, [
        _createVNode(_component_router_link, {
          to: { name: 'Dashboard' },
          class: _normalizeClass(["menu-link", _ctx.route.name == 'Dashboard' ? 'current-link' : ''])
        }, {
          default: _withCtx(() => [
            _hoisted_13,
            _hoisted_14
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _createElementVNode("li", _hoisted_15, [
        _createVNode(_component_router_link, {
          to: { name: 'CustomerQuotation' },
          class: _normalizeClass(["menu-link", _ctx.route.name == 'CustomerQuotation' ? 'current-link' : ''])
        }, {
          default: _withCtx(() => [
            _hoisted_16,
            _hoisted_17
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _createElementVNode("li", _hoisted_18, [
        _createVNode(_component_router_link, {
          to: { name: 'CustomerPurchaseHistory' },
          class: _normalizeClass(["menu-link", 
            _ctx.route.name.includes(
              'CustomerPurchaseHistory',
              'CustomerOrderDetails'
            )
              ? 'current-link'
              : ''
          ])
        }, {
          default: _withCtx(() => [
            _hoisted_19,
            _hoisted_20
          ]),
          _: 1
        }, 8, ["class"])
      ])
    ]),
    _hoisted_21
  ]))
}